import { jsx as _jsx } from "react/jsx-runtime";
import { NoResultsContainer } from "@faire/retailer-visitor-shared/components/NoResults/index";
import { useClearCategoryPageFilters } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/NoResults/__internal__/useClearCategoryPageFilters";
import { useIsCategoryPageFiltered } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/__internal__/NoResults/__internal__/useIsCategoryPageFiltered";
import React from "react";
export var CategoryPageNoResults = function(param) {
    var showProductFirstResults = param.showProductFirstResults, categoryPageLoadTimingRef = param.categoryPageLoadTimingRef;
    var isFiltered = useIsCategoryPageFiltered();
    var handleClearFilters = useClearCategoryPageFilters();
    return /*#__PURE__*/ _jsx(NoResultsContainer, {
        showProductFirstResults: showProductFirstResults,
        hasFiltersApplied: isFiltered,
        onClearFilters: handleClearFilters,
        divRef: categoryPageLoadTimingRef
    });
};
